import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import './Main.css';

import Header from '../../Components/Header/Header'
import Form from '../../Components/Form/Form'
import Result from '../../Components/Result/Result'

const Main = () => {

  useEffect(() => {
  }, [])

  return (
    <main className="main-container">
      <Header />
      <div className="content-container">
      <Routes>
        <Route path="/" element={<Form />} />
        <Route path="/result" element={<Result />} />
        <Route path="*" element={<Form />} />
      </Routes>
      </div>
    </main>
  )
}

export default Main
